import { useRouter } from "next/router";
import { useCallback } from "react";
import { PagesEnum } from "../../../utils/enums";
import { getPageLink } from "../../../utils/help/navigation/navigation";
import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { selectIsPayWithPointsApplied } from "../../redux/selectors/payWithPointsSelectors";
import { useModalHook } from "../useModal";
import { useAppSelector } from "../useReduxHooks";

/**
 * Opening a BOGO or bundle, from wherever the guest reaches for it.
 *
 * These are ordinary offers, so they owe the same points-versus-offer question
 * every other offer answers before it is redeemed — an applied points discount
 * and an offer cannot both stand. The only difference is when the question
 * lands: a normal offer is applied on the spot, while these have to be built
 * first, so asking at the end would waste the building. Choosing the offer in
 * the chooser reopens its own popup, which routes here in turn.
 *
 * Without this, `commitLoyaltyOfferBuilder` dropped the points discount at the
 * end with nothing having asked.
 */
export const useOpenGuestBuiltOffer = () => {
  const router = useRouter();
  const { handleModal } = useModalHook();
  const isPayWithPointsApplied = useAppSelector(selectIsPayWithPointsApplied);

  return useCallback(
    (offer: LoyaltyOffer) => {
      if (isPayWithPointsApplied) {
        handleModal(true, "LoyaltyOffersPopup/LoyaltyOffersPopup", {
          componentProps: { pendingOffer: offer.toPlain() },
        });

        return;
      }

      router.push(getPageLink(router, PagesEnum.Offer, { as: offer.id }).as);
    },
    [router, handleModal, isPayWithPointsApplied]
  );
};
